import { globalStyle, style } from '@vanilla-extract/css';

import { column } from '../columns/Column.css';
import { documentContainer } from '../document/Document.css';
import { section } from '../section/Section.css';

export const bulletListContainer = style({
  selectors: {
    [`${documentContainer} > &, ${section} > &, ${column} > &`]: {
      paddingLeft: 'calc(var(--wt-padding, 10px) + var(--wt-list-padding-left, 27px))',
      paddingRight: 'calc(var(--wt-padding, 10px) + var(--wt-list-padding-right, 17px))',
      paddingTop: 'var(--wt-list-padding-top, 12px)',
      paddingBottom: 'var(--wt-list-padding-bottom, 12px)',
    },
  },
});

export const bulletList = style({
  color:
    'var(--post-section-text-color, var(--site-theme-text-on-background-color, var(--wt-list-font-color, #000000)))',
  margin: '0px 0px 0px 25px',
  padding: '0',
  fontSize: 'var(--wt-list-font-size, 16px)',
  fontFamily: 'var(--wt-list-font-family, Arial)',
  listStyleType: 'disc',
  lineHeight: 'var(--wt-list-line-height-size, 1.5)',
  fontWeight: 'var(--wt-list-font-weight, normal)',
});

// Nested bullet lists cycle through disc, circle, square
globalStyle(`${bulletList} ul`, {
  listStyleType: 'circle',
});

globalStyle(`${bulletList} ul ul`, {
  listStyleType: 'square',
});

globalStyle(`${bulletList} ul ul ul`, {
  listStyleType: 'disc',
});

globalStyle(`${bulletList} ul ul ul ul`, {
  listStyleType: 'circle',
});

globalStyle(`${bulletList} ul ul ul ul ul`, {
  listStyleType: 'square',
});

globalStyle(`${bulletList} ul ul ul ul ul ul`, {
  listStyleType: 'disc',
});

globalStyle(`${bulletList} ul ul ul ul ul ul ul`, {
  listStyleType: 'circle',
});

globalStyle(`${bulletList} ul ul ul ul ul ul ul ul`, {
  listStyleType: 'square',
});
